'use client';

import * as React from 'react';

import SuccessModal from './SuccessModal';

interface SignupContextData {
  userEmail: string | null;
  isModalVisible: boolean;
  handleSuccess: (email: string) => void;
  handleDismiss: () => void;
}

const SignupContext = React.createContext<SignupContextData>({
  userEmail: null,
  isModalVisible: false,
  handleSuccess: () => {},
  handleDismiss: () => {},
});

function SignupProvider({ children }: { children: React.ReactNode }) {
  const [userEmail, setUserEmail] = React.useState<string | null>(
    null
  );
  const [isModalVisible, setIsModalVisible] =
    React.useState<boolean>(false);

  const handleSuccess = React.useCallback((email: string) => {
    setUserEmail(email);
    setIsModalVisible(true);
  }, []);

  const handleDismiss = React.useCallback(() => {
    setIsModalVisible(false);
  }, []);

  return (
    <SignupContext.Provider
      value={{
        userEmail,
        isModalVisible,
        handleSuccess,
        handleDismiss,
      }}
    >
      {children}

      <SuccessModal
        email={userEmail}
        isOpen={isModalVisible}
        handleDismiss={handleDismiss}
      />
    </SignupContext.Provider>
  );
}

export function useSignupContext() {
  return React.useContext(SignupContext);
}

export default SignupProvider;
